import React, { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "../tss";
import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Rocketmail from "../images/Rocketmail.png";
import { useNavigate, useLocation } from "react-router-dom";
import { SIGNIN_ROUTE } from "../constants/RoutePaths";
import { VERIFY_EMAIL_URL } from "../comman/url";
import API from "../constants/API";
import { useSnackbar } from "notistack";
import { CustomMessage } from "../comman/helperfunction";

const useStyles = makeStyles((_theme: any) => ({
  // TODO(types): MUI theme
  shadow1: {
    width: "100%",
    backgroundColor: "unset !important",
    boxShadow: "none !important",
    padding: "24px",
    marginTop: "48px",
  },
  regimg: {
    width: "25%",
  },
  regtext: {
    // width: "72%",
    // display: "flex",
    margin: "auto !important",
    // [theme.breakpoints.up("md")]: {
    //   width: "100%",
    // },
  },
  pleasetext: {
    margin: "auto !important",
    fontSize: "14px !important",
    color: "#A0A3BD !important",
  },
  buttontext: {
    backgroundColor: "#EC7C37 !important",
    boxShadow: "none !important",
    "&:hover": {
      color: "#EC7C37 !important",
      border: "1px solid #EC7C37 !important",
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
    },
  },
}));

const VerifyEmail = () => {
  const location = useLocation();
  const styleclasses = useStyles();
  const history = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [data, setData] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const Item = styled(Paper)(({ theme }: any) => ({
    // TODO(types): MUI styled props
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const gotoSigin = () => {
    history(SIGNIN_ROUTE);
  };

  useEffect(() => {
    VerifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // intentional: mount-only; VerifyEmail is component-scope

  const VerifyEmail = async () => {
    const emailvalue = searchParams.get("email");
    const newEmailValue = decodeURIComponent(emailvalue.replace(" ", "+"));
    const config = {
      method: "PUT",
      url: VERIFY_EMAIL_URL,
      data: {
        email: newEmailValue,
        hashKey: searchParams.get("hashKey"),
      },
    };
    try {
      const response = await API(config);
      //const { status, message } = response.data;
      const { status, message } = response.data;

      if (status === "Success") {
        setData("Thank you. You have successfully verified your email address with us");
        //Swal.fire(getAlertToast("success", "Email Verified Successfully"));
        CustomMessage("Email verified", "success", enqueueSnackbar);
      } else {
        setData(message);
        // Swal.fire(getAlertToast(message));
        CustomMessage(message, "error", enqueueSnackbar); //call toster
      }
    } catch (error: any) {
      // TODO(types): error object
      // let errorObj = Object.assign({}, error);
      // let { data } = errorObj.response;
      if (error.response) {
        const { data } = error.response;

        const v = data;

        setData(v.message);

        CustomMessage(v.message, "error", enqueueSnackbar); //call toster
      }
    }
  };

  return (
    <Fragment>
      <Box sx={{ width: "100%", mt: 2 }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          rowSpacing={2}
          columnSpacing={{ xs: 4, sm: 4, md: 4 }}
        >
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <Item className={styleclasses.shadow1}>
              <img src={Rocketmail} className={styleclasses.regimg}></img>
            </Item>

            <Grid className={styleclasses.regtext} size={{ xs: 12, md: 12, lg: 12 }}>
              <Typography align="center" variant="h6">
                {data}
              </Typography>
            </Grid>
            {/* <Grid sx={{ p: 2, fontWeight: 600 }} size={{ xs: 12, md: 12, lg: 12 }}>
              <Typography align="center" className={styleclasses.pleasetext}>
                Please check your spam/junk folder if you do not see any
                messages from EZ Cloud in your inbox.
              </Typography>
            </Grid> */}
            <Grid sx={{ p: 2, fontWeight: 600 }} size={{ xs: 12, md: 12, lg: 12 }}>
              <Button
                className={styleclasses.buttontext}
                variant="contained"
                onClick={() => gotoSigin()}
              >
                Signin
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
};

export default VerifyEmail;
